/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/location';
import '../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbqualifier": {
        "nested": {
          "service": {
            "nested": {
              "KybBusinessType": {
                "values": {
                  "UNKNOWN_KYB_BUSINESS_TYPE": 0,
                  "LIMITED_LIABILITY_COMPANY": 1,
                  "SOLE_PROPRIETORSHIP": 2,
                  "C_CORPORATION": 3,
                  "S_CORPORATION": 4,
                  "PARTNERSHIP": 5,
                  "PUBLIC_COMPANY": 6,
                  "NONPROFIT": 7,
                  "INDIVIDUAL_SOLE_TRADER": 8,
                  "COMPANY": 9,
                  "OTHER": 10,
                  "COOPERATIVE": 11,
                  "SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": 12
                }
              },
              "IdentificationNumberType": {
                "values": {
                  "UNKNOWN_IDENTIFICATION_NUMBER_TYPE": 0,
                  "EIN": 1,
                  "ITIN": 2,
                  "SSN": 3,
                  "CHRN": 4
                }
              },
              "KybPersonRole": {
                "values": {
                  "UNKNOWN_KYB_PERSON_ROLE": 0,
                  "SQ_ACCOUNT_HOLDER": 1,
                  "SOLE_PROPRIETOR": 2,
                  "BUSINESS_MANAGER": 3,
                  "BENEFICIAL_OWNER": 4
                }
              },
              "KybPersonaName": {
                "fields": {
                  "firstName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "middleName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "lastName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "KybBusiness": {
                "fields": {
                  "legalName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "businessNameDba": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "businessAddress": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 3,
                    "rule": "optional"
                  },
                  "businessType": {
                    "type": "squareup.bbqualifier.service.KybBusinessType",
                    "id": 4,
                    "rule": "optional"
                  },
                  "businessIdentificationNumber": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "identificationNumberType": {
                    "type": "squareup.bbqualifier.service.IdentificationNumberType",
                    "id": 6,
                    "rule": "optional"
                  },
                  "legalEntityToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "dateEstablished": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "stateOfIncorporation": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  }
                }
              },
              "KybPersona": {
                "fields": {
                  "roles": {
                    "type": "squareup.bbqualifier.service.KybPersonRole",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "name": {
                    "type": "squareup.bbqualifier.service.KybPersonaName",
                    "id": 2,
                    "rule": "optional"
                  },
                  "dateOfBirth": {
                    "type": "squareup.common.time.YearMonthDay",
                    "id": 3,
                    "rule": "optional"
                  },
                  "nationalIdNumber": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "personalAddress": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 5,
                    "rule": "optional"
                  },
                  "legalEntityToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "phone": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "fullNationalId": {
                    "type": "string",
                    "id": 7
                  },
                  "nationalIdSummary": {
                    "type": "squareup.bbqualifier.service.KybPersona.NationalIdentificationNumberSummary",
                    "id": 8
                  }
                },
                "nested": {
                  "NationalIdentificationNumberSummary": {
                    "fields": {
                      "fideliusToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "lastFour": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "national_id": {
                    "oneof": ["fullNationalId", "nationalIdSummary"]
                  }
                }
              },
              "KybAttestation": {
                "fields": {
                  "name": {
                    "type": "squareup.bbqualifier.service.KybPersonaName",
                    "id": 1,
                    "rule": "optional"
                  },
                  "dateOfConsent": {
                    "type": "squareup.common.time.YearMonthDay",
                    "id": 2,
                    "rule": "optional"
                  },
                  "consent": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.KybBusinessType && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.IdentificationNumberType && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.KybPersonRole && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.KybPersonaName && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.KybBusiness && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.KybPersona && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.KybPersona?.nested?.NationalIdentificationNumberSummary && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.KybAttestation) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE KybBusinessType @ squareup/bbqualifier/kyb_model.proto at 14:1
 */
export const KybBusinessType = $root.lookupEnum('squareup.bbqualifier.service.KybBusinessType').values;
/**
 * We don't currently collect any unique ID number in CA.
 *
 * SOURCE IdentificationNumberType @ squareup/bbqualifier/kyb_model.proto at 34:1
 */
export const IdentificationNumberType = $root.lookupEnum('squareup.bbqualifier.service.IdentificationNumberType').values;
/**
 * SOURCE KybPersonRole @ squareup/bbqualifier/kyb_model.proto at 42:1
 */
export const KybPersonRole = $root.lookupEnum('squareup.bbqualifier.service.KybPersonRole').values;
/**
 * SOURCE KybPersonaName @ squareup/bbqualifier/kyb_model.proto at 50:1
 */
export const KybPersonaName = $root.lookupType('squareup.bbqualifier.service.KybPersonaName');
fixType(KybPersonaName, {
  firstName: {
    required: true
  },
  lastName: {
    required: true
  }
});
Builder.createAndAttachToType(KybPersonaName);
/**
 * SOURCE KybBusiness @ squareup/bbqualifier/kyb_model.proto at 60:1
 */
export const KybBusiness = $root.lookupType('squareup.bbqualifier.service.KybBusiness');
fixType(KybBusiness, {
  legalName: {
    required: true
  },
  businessType: {
    required: true
  }
});
Builder.createAndAttachToType(KybBusiness);
/**
 * SOURCE KybPersona @ squareup/bbqualifier/kyb_model.proto at 77:1
 */
export const KybPersona = $root.lookupType('squareup.bbqualifier.service.KybPersona');
fixType(KybPersona, {
  roles: {
    required: true
  },
  name: {
    required: true
  }
});
Builder.createAndAttachToType(KybPersona);
/**
 * SOURCE NationalIdentificationNumberSummary @ squareup/bbqualifier/kyb_model.proto at 78:3
 */
KybPersona.NationalIdentificationNumberSummary = $root.lookupType('squareup.bbqualifier.service.KybPersona.NationalIdentificationNumberSummary');
fixType(KybPersona.NationalIdentificationNumberSummary);
Builder.createAndAttachToType(KybPersona.NationalIdentificationNumberSummary);
/**
 * SOURCE KybAttestation @ squareup/bbqualifier/kyb_model.proto at 104:1
 */
export const KybAttestation = $root.lookupType('squareup.bbqualifier.service.KybAttestation');
fixType(KybAttestation, {
  dateOfConsent: {
    required: true
  },
  consent: {
    required: true
  }
});
Builder.createAndAttachToType(KybAttestation);